<script lang="ts">
import { Component, mixins } from 'vue-facing-decorator';
import { RevealMixin } from '../mixins/reveal';

@Component
export default class Faq extends mixins(RevealMixin) {
  faqKeys = ['q1', 'q2', 'q3', 'q4', 'q5'] as const;
}
</script>

<template>
  <section id="faq" class="border-t border-edge py-24">
    <div class="mx-auto max-w-3xl px-6">
      <p data-reveal class="font-mono text-xs font-semibold tracking-[0.22em] text-signal uppercase" v-cipher="$t('faq.eyebrow')"></p>
      <h2 data-reveal class="mt-4 font-display text-4xl font-bold tracking-tight md:text-5xl" v-cipher="$t('faq.title')"></h2>

      <div class="mt-14 space-y-3">
        <details
          v-for="k in faqKeys"
          :key="k"
          data-reveal
          class="group rounded-xl border border-edge bg-surface transition-colors open:border-signal/50"
        >
          <summary class="flex min-h-[88px] cursor-pointer list-none items-center justify-between gap-4 px-6 py-5 font-semibold [&::-webkit-details-marker]:hidden md:min-h-[64px]">
            <span v-cipher="$t('faq.items.' + k + '.q')"></span>
            <svg class="h-4 w-4 shrink-0 text-muted transition-transform duration-300 group-open:rotate-45" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </summary>
          <p class="px-6 pb-6 text-sm leading-relaxed text-muted" v-cipher="$t('faq.items.' + k + '.a')"></p>
        </details>
      </div>
    </div>
  </section>
</template>